









































































import { Component, Vue, Prop } from 'vue-property-decorator'

import Header from '@/components/Header.vue'
import Page from '@/components/Page.vue'

@Component<PrivacyView>({
  components: {
    Header,
    Page
  },
  // @ts-ignore
  head: {
    title () {
      return {
        inner: `${this.$t('footer.privacy')}`
      }
    }
  }
})
export default class PrivacyView extends Vue {}
